// extracted by mini-css-extract-plugin
export default {"uploader":"uploader_uploader__mEb-E","uploader__icon":"uploader_uploader__icon__AeC4K"};